module.exports = __webpack_public_path__ + "img/d200805a.77aa7091.jpg";